import request from '@/utils/request'

// ==================== 课程类别相关接口 ====================

// 获取所有课程类别
export function getCourseCategories() {
  return request({
    url: '/teach-course-categories',
    method: 'get'
  })
}

// 添加课程类别
export function addCourseCategory(data) {
  return request({
    url: '/teach-course-categories',
    method: 'post',
    data
  })
}

// 更新课程类别
export function updateCourseCategory(data) {
  return request({
    url: '/teach-course-categories',
    method: 'put',
    data
  })
}

// 删除课程类别
export function deleteCourseCategory(id) {
  return request({
    url: `/teach-course-categories/${id}`,
    method: 'delete'
  })
}

// 根据ID获取课程类别详情
export function getCourseCategoryById(id) {
  return request({
    url: `/teach-course-categories/${id}`,
    method: 'get'
  })
}

// 根据类别ID获取课程列表
export function getCoursesByCategoryId(categoryId) {
  return request({
    url: `/teachcourse/category/${categoryId}`,
    method: 'get'
  })
}

// ==================== 课程相关接口 ====================

// 获取教学课程列表
export function getTeachingCourses() {
  return request({
    url: '/teachcourse/list',
    method: 'get'
  })
}

// 创建课程
export function createCourse(data) {
  return request({
    url: '/teachcourse/add',
    method: 'post',
    data
  })
}

// 更新课程
export function updateCourse(data) {
  return request({
    url: '/teachcourse/update',
    method: 'put',
    data
  })
}

// 删除课程
export function deleteCourse(id) {
  return request({
    url: `/teachcourse/${id}`,
    method: 'delete'
  })
}

// 获取课程列表
export function getCourseList() {
  return request({
    url: '/teachcourse/list',
    method: 'get'
  })
}

// 获取单个课程
export function getCourseById(courseId) {
  return request({
    url: `/teachcourse/${courseId}`,
    method: 'get'
  })
}

// 添加课程
export function addCourse(courseData) {
  return request({
    url: '/teachcourse/add',
    method: 'post',
    data: courseData
  })
}

// 上传课程封面
export function uploadCourseCover(courseId, formData) {
  return request({
    url: `/teachcourse/uploadCover/${courseId}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 上传课程图片
export function uploadCourseImage(formData) {
  return request({
    url: '/teachcourse/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取学生选课列表
export function studentSelectedCourse(userId) {
  return request({
    url: `/user/course/list/${userId}`,
    method: 'get'
  })
}

// 学生选课
export function selectCourse(studentId, courseData) {
  return request({
    url: `/user/course/select/${studentId}`,
    method: 'post',
    data: courseData
  })
}

// 获取可选课程列表
export function getAvailableCourses() {
  return request({
    url: '/user/course/available',
    method: 'get'
  })
}

// 退选课程
export function dropCourse(selectionId) {
  return request({
    url: `/user/course/drop/${selectionId}`,
    method: 'delete'
  })
}

// 获取课程通知列表（教师用）
export function getCourseNotices(pageNum, pageSize, title, courseId, userId) {
  return request({
    url: '/course/notices/paging',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      title,
      courseId,
      userId // 添加userId参数
    }
  })
}

// 获取最新通知（学生用）
export function getNewCourseNotices(pageNum, pageSize, courseId, userId) {
  return request({
    url: '/course/notices/new',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      courseId,
      userId // 添加userId参数
    }
  })
}

// 添加课程通知
export function addCourseNotice(data) {
  return request({
    url: '/course/notices',
    method: 'post',
    data
  })
}

// 更新课程通知
export function updateCourseNotice(noticeId, data) {
  return request({
    url: `/course/notices/${noticeId}`,
    method: 'put',
    data
  })
}

// 删除课程通知
export function deleteCourseNotice(ids) {
  return request({
    url: `/course/notices/${ids}`,
    method: 'delete'
  })
}

// ==================== 课程班级管理相关接口 ====================

// 添加课程班级关联
export function addCourseGrade(data) {
  return request({
    url: '/course-grades/add',
    method: 'post',
    data
  })
}

// 删除课程班级关联
export function deleteCourseGrade(id) {
  return request({
    url: `/course-grades/delete/${id}`,
    method: 'delete'
  })
}

// 根据课程ID获取关联的班级列表
export function getGradesByCourseId(courseId) {
  return request({
    url: `/course-grades/course/${courseId}`,
    method: 'get'
  })
}

// 根据教师ID和课程ID获取关联的班级列表
export function getGradesByCourseIdAndTeacherId(courseId, teacherId) {
  return request({
    url: `/course-grades/course/${courseId}/teacher/${teacherId}`,
    method: 'get'
  })
}

// 根据班级ID获取关联的课程列表
export function getCoursesByGradeId(gradeId) {
  return request({
    url: `/course-grades/grade/${gradeId}`,
    method: 'get'
  })
}

// 批量添加课程班级关联
export function batchAddCourseGrades(courseId, gradeIds) {
  return request({
    url: '/course-grades/batch-add',
    method: 'post',
    params: { courseId },
    data: gradeIds
  })
}

// 批量删除课程班级关联
export function batchDeleteCourseGrades(courseId, gradeIds) {
  return request({
    url: '/course-grades/batch-delete',
    method: 'delete',
    params: { courseId },
    data: gradeIds
  })
}
